(function () {
  'use strict';

  // Only run on product pages
  const bar = document.querySelector('.jn-sticky-atc');
  if (!bar) return;

  // Watch the native buy-buttons wrapper to know when it's scrolled out of view
  const buyButtons = document.querySelector('.product-form__buttons');
  if (!buyButtons) return;

  // Show the bar when the native ATC scrolls above the viewport
  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        const aboveViewport =
          !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('jn-sticky-atc--visible', aboveViewport);
        bar.setAttribute('aria-hidden', String(!aboveViewport));
      });
    },
    { threshold: 0 }
  );

  observer.observe(buyButtons);

  // Delegate click on sticky button to the real product form submit button
  // This keeps all cart logic (variant selection, quantity, AJAX) in product-form.js
  const stickyBtn = bar.querySelector('.jn-sticky-atc__btn');
  if (!stickyBtn) return;

  stickyBtn.addEventListener('click', function () {
    const formId =
      bar.dataset.formId ||
      bar.id.replace('JnStickyAtc-', 'product-form-');

    const submitBtn = document.querySelector(
      '#' + formId + ' [type="submit"][name="add"]'
    );

    if (submitBtn) {
      submitBtn.click();
    }
  });
})();
